import { ExpandLess as IconExpandLess, ExpandMore as IconExpandMore } from "@mui/icons-material";
import { Box, Card, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { FinalReportWeatherCardTableHeader } from "./FinalReportWeatherCardTableHeader";
import FinalReportWeatherCardTableRow from "./FinalReportWeatherCardTableRow";
import { FinalReportWeatherCardFragment } from "./fragment.generated";

type Props = {
    weatherReport: FinalReportWeatherCardFragment;
};
export default function FinalReportWeatherCard({ weatherReport }: Props) {
    const { t } = useTranslation("project");

    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Stack rowGap={2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">
                        {t("projectReviewVisitV2.finalReportRoute.finalReportWeatherCard.weatherCardTitle")}
                    </Typography>
                    <Box>
                        <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                            {isCollapsed ? <IconExpandLess /> : <IconExpandMore />}
                        </IconButton>
                    </Box>
                </Stack>
                {isCollapsed === true && (
                    <Box
                        sx={theme => ({
                            display: "grid",
                            gridTemplateColumns: "2fr 1fr 1fr",
                            border: `1px solid ${theme.palette.divider}`,
                            "& > *": {
                                borderBottom: `1px solid ${theme.palette.divider}`,
                            },
                        })}
                    >
                        <FinalReportWeatherCardTableHeader />
                        {weatherReport.conditions.map(condition => (
                            <FinalReportWeatherCardTableRow
                                key={condition.name}
                                metric={t(
                                    `projectReviewVisitV2.finalReportRoute.finalReportWeatherCardTableRow.metrics.${condition.name}`,
                                )}
                                condition={condition}
                            />
                        ))}
                    </Box>
                )}
            </Stack>
        </Card>
    );
}
